var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08167 12.4183 0.5 8 0.5C3.58173 0.5 0 4.08167 0 8.5C0 12.9183 3.58173 16.5 8 16.5ZM3.96967 5.5304L6.93933 8.5L3.96967 11.4697L5.03033 12.5304L8 9.56067L10.9697 12.5304L12.0303 11.4697L9.06067 8.5L12.0303 5.5304L10.9697 4.46973L8 7.43945L5.03033 4.46973L3.96967 5.5304Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.56ee16bb1ed4c52ad9b3a9389251429e.svg";
export { ForwardRef as ReactComponent };